export class ApplicationConfigurationDto {
  localization: LocalizationDto = new LocalizationDto;
  auth: AuthConfigurationDto = new AuthConfigurationDto;
  setting: any | null;
  currentUser: any | null;
  features: any | null;
  multiTenancy: any | null;
  currentTenant: any | null;
  timing: any | null;
  clock: any | null;
  objectExtensions: any | null;
}

export class AuthConfigurationDto {
  grantedPolicies: Record<string, boolean> = {};
  policies: Record<string, boolean> = {};
}

export class LocalizationDto {
  languages: Array<LanguageDto> = new Array<LanguageDto>()
  values: Record<string, Record<string, string>> = {}
}

export class LanguageDto {
  cultureName!: string;
  uiCultureName!: string;
  displayName!: string;
  flagIcon: string | null = null;
}
